var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-mobile-panel-button"},[_c('icons-arrow-left',{attrs:{"color":"#000","width":12,"height":19}}),_c('div',{staticClass:"close-mobile-panel-button__content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }